import { Button } from "../ui/button";
import { motion } from "framer-motion";
import { useNavigate } from "react-router-dom";

const Header = () => {
  const navigate = useNavigate();

  const handleLogin = () => {
    navigate('/login');
  };

  const handleJoinWaitlist = () => {
    navigate('/join-waitlist');
  };

  return (
    <motion.header
      initial={{ opacity: 0, y: -10 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.5 }}
      className="fixed top-0 left-0 right-0 z-50 bg-background/80 backdrop-blur-md border-b border-border"
    >
      <div className="container-narrow mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-16">
          {/* Logo - Small icon on mobile, full logo on desktop */}
          <div className="flex items-center gap-3">
            {/* Small logo - always visible */}
            <img
              src="/logo-small.png"
              alt="AccountsGenie"
              className="h-10 w-10 object-contain md:hidden"
            />
            {/* Long logo - visible on desktop */}
            <img
              src="/logo-long.png"
              alt="AccountsGenie"
              className="hidden md:block h-10 object-contain"
            />
          </div>

          <nav className="hidden md:flex items-center gap-6 text-sm text-muted-foreground">
            <a href="#" className="hover:text-foreground transition-colors">Features</a>
            <a href="#" className="hover:text-foreground transition-colors">Pricing</a>
            <a href="#" className="hover:text-foreground transition-colors">About</a>
            <a href="#" className="hover:text-foreground transition-colors">Contact</a>
          </nav>

          <div className="flex items-center gap-3">
            <Button variant="ghost" size="sm" className="hidden sm:inline-flex" onClick={handleLogin}>
              Login
            </Button>
            <Button size="sm" className="bg-primary hover:bg-primary/90 text-primary-foreground" onClick={handleJoinWaitlist}>
              Join the Waitlist
            </Button>
          </div>
        </div>
      </div>
    </motion.header>
  );
};

export default Header;
